import axios from 'axios';

const NASA_API_URL = 'https://power.larc.nasa.gov/api/temporal/climatology/point';

export default {
  async getHSP(lat, lon) {
    try {
      const response = await axios.get(NASA_API_URL, {
        params: {
          parameters: 'ALLSKY_SFC_SW_DWN',
          community: 'RE',
          longitude: lon,
          latitude: lat,
          format: 'JSON'
        }
      });
      
      return response.data.properties.parameter.ALLSKY_SFC_SW_DWN;
    } catch (error) {
      console.error("Error NASA API:", error);
      return null;
    }
  }
};